import { useState } from "react";
import { range } from "~/utils/belt";
import { Button } from "../shared/Button";
import { useNavigate } from "react-router";
import type { TournamentProps } from "~/helpers/prepare-tournament-data";

const FeaturedTournaments: React.FC<{
  tournaments: TournamentProps[];
}> = ({ tournaments }) => {
  const navigate = useNavigate();
  const [selectedIndex, setSelectedIndex] = useState<number>(1);
  return (
    <div className="mt-8">
      <h2 className="text-grey-dark dark:text-jiwe-blue text-base uppercase font-bold mb-4">
        Featured
      </h2>
      {tournaments.map((tournament, index) => (
        <div
          key={tournament.id}
          style={{
            display:
              index + 1 === selectedIndex
                ? "flex flex-col lg:flex-row"
                : "none",
          }}
        >
          <div className="flex flex-col w-full lg:w-6/12">
            {/* Title */}
            <h3 className="text-grey-night dark:text-grey-border uppercase font-bold text-xl min-w-[30%]">
              {tournament.name}
            </h3>
            <h4 className="text-sm text-grey-dark uppercase">
              {tournament.game}
            </h4>
            <div className="flex flex-col justify-start items-start">
              <Button
                type="button"
                onClick={() => navigate(`/tournaments/${tournament.id}`)}
                size="small"
                className="!text-[#ffffff] text-xs hidden lg:block bg-jiwe-dark-blue leading-none !px-3 !py-2 !pt-[0.625rem]"
              >
                View Tournament
              </Button>
              {/* Slideshow indicators */}
              {range(tournaments.length).length > 1 && (
                <div className="flex gap-x-2 mt-8">
                  {range(tournaments.length).map((count) => (
                    <button
                      key={`11-${count}`}
                      className={`rounded-xl h-3 w-3 border-2 border-jiwe-dark-blue dark:border-[transparent] bg-jiwe-dark-blue dark:bg-[#fff] ${
                        count !== selectedIndex
                          ? "dark:bg-jiwe-blue bg-[#fff] opacity-70"
                          : ""
                      }`}
                      type="button"
                      onClick={() => setSelectedIndex(count)}
                    />
                  ))}
                </div>
              )}
            </div>
          </div>
          {/* Image */}
          <div className="mt-4 lg:mt-2">
            <img
              src={tournament.posterURL}
              alt={`${tournament.name} poster`}
              className="z-0 bg-cover bg-left-top w-full lg:w-[60%] h-auto lg:ml-4"
              style={{ transform: "translateZ(0) scale(1.05)" }}
            />
            <Button
              type="button"
              onClick={() => navigate(`/tournaments/${tournament.id}`)}
              size="small"
              className="!text-[#ffffff] text-xs block lg:hidden bg-jiwe-dark-blue leading-none !px-3 !py-2 !pt-[0.625rem]"
            >
              View Tournament
            </Button>
          </div>
        </div>
      ))}
    </div>
  );
};

export default FeaturedTournaments;
